class StockistFilter extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector('[data-stockist-search]');
    this.countrySelect = this.querySelector('[data-stockist-country]');
    this.items = Array.from(this.querySelectorAll('[data-stockist-item]'));
    this.groups = Array.from(this.querySelectorAll('[data-stockist-group]'));
    this.countLabel = this.querySelector('[data-stockist-count]');
    this.emptyMessage = this.querySelector('[data-stockist-empty]');
    this.total = this.items.length;

    this.onFilter = this.onFilter.bind(this);
    this.searchInput.addEventListener('input', this.onFilter);
    this.countrySelect.addEventListener('change', this.onFilter);

    this.onFilter();
  }

  onFilter() {
    const query = this.searchInput.value.trim().toLowerCase();
    const country = this.countrySelect.value;
    let visibleCount = 0;

    this.items.forEach((item) => {
      const matchesSearch = query === '' || item.dataset.search.includes(query);
      const matchesCountry = country === '' || item.dataset.country === country;
      const isVisible = matchesSearch && matchesCountry;
      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    this.groups.forEach((group) => {
      const hasVisibleItem = group.querySelector('[data-stockist-item]:not([hidden])') !== null;
      group.hidden = !hasVisibleItem;
    });

    this.countLabel.textContent = this.countLabel.dataset.template
      .replace('[[count]]', visibleCount)
      .replace('[[total]]', this.total);

    this.emptyMessage.hidden = visibleCount !== 0;
  }
}

customElements.get('stockist-filter') || customElements.define('stockist-filter', StockistFilter);
